export default __webpack_public_path__ + "static/media/BARRA_black.ce3bde55.svg";